import React from 'react';
import './scss/footer.scss';
import SelectEnvComponent from "./select-env-component";

function Footer(): React.ReactElement {
    return (
        <footer className="text-center text-md-start bg-light mt-5">
            <section className="container">
                <div className="row">
                    <div className="col">
                        <h6 className="text-uppercase mb-3" style={{fontWeight: 'bold'}}>About EDS</h6>
                        <p className="fst-italic">
                            EverdreamSoft (EDS) is a swiss-based company founded in 2010 as a game studio.
                            Since 2014 EDS has been pioneering integration and use of blockchain tools in the
                            domain of gaming and digital collectibles.
                        </p>
                        <p className="fst-italic">
                            EDS is also the creator of Everdream Soft Crystal Suite, an integrated suite of
                            tools allowing you to explore, create, share and
                            manage “Orbs” – rare digital items (art, game items, collectibles)
                            linked to blockchain token.
                        </p>
                    </div>
                    <div className="col">
                        <div className="ps-2 pt-2 normal-text-italic">
                            <strong>Creator of "Spells of Genesis"</strong>
                        </div>
                        <div className="ps-2 pt-2 normal-text-italic">
                            The 1st NFTs mobile game ever made, since 2015
                        </div>
                        <div className="pt-4">
                            <img src="https://spellsofgenesis.com/everdreamsoft.webp" className="" alt="EDS"
                                 title="EDS"/>
                        </div>
                        <div className="ps-2 pt-2 normal-text-italic">
                            <strong>Unlocking Access to the Creative Economy</strong>
                        </div>
                    </div>
                </div>
                <div className="row d-none">
                    <div className="col-md-2  mx-auto ">
                        <h6 className="text-uppercase mb-4 font-weight-bold">EDS NFT</h6>
                        <p>
                            Here you can use rows and columns to organize your footer content. Lorem ipsum dolor
                            sit amet, consectetur adipisicing
                        </p>
                    </div>
                    <hr className="w-100 clearfix d-md-none"/>
                    <div className="col-md-2  mx-auto ">
                        <h6 className="text-uppercase mb-4 font-weight-bold">
                            About Us
                        </h6>
                        <p>
                            <a href="/">Terms</a>
                        </p>
                        <p>
                            <a href="/">About EDS</a>
                        </p>
                        <p>
                            <a href="/">Community</a>
                        </p>
                    </div>
                    <hr className="w-100 clearfix d-md-none"/>
                    <div className="col-md-2  mx-auto ">
                        <h6 className="text-uppercase mb-4 font-weight-bold">
                            Services
                        </h6>
                        <p>
                            <a href="/">Terms</a>
                        </p>
                        <p>
                            <a href="/">About EDS</a>
                        </p>
                        <p>
                            <a href="/">Community</a>
                        </p>
                    </div>
                    <hr className="w-100 clearfix d-md-none"/>
                    <div className="col-md-2  mx-auto ">
                        <h6
                            className="text-uppercase mb-4 font-weight-bold"
                        >
                            Products
                        </h6>
                        <p>
                            <a href="/">Terms</a>
                        </p>
                        <p>
                            <a href="/">About EDS</a>
                        </p>
                        <p>
                            <a href="/">Community</a>
                        </p>
                    </div>
                    <hr className="w-100 clearfix d-md-none"/>
                    <div className="col-md-2 mx-auto ">
                        <h6 className="text-uppercase mb-4 font-weight-bold">
                            Collections
                        </h6>
                        <p>
                            <a href="/">Trending</a>
                        </p>
                        <p>
                            <a href="/">Highest Volumes</a>
                        </p>
                    </div>
                    <hr className="w-100 clearfix d-md-none"/>
                    <div className="col-md-2 mx-auto ">
                        <h6 className="text-uppercase mb-4 font-weight-bold">
                            Social
                        </h6>
                        <p>
                            <a href="/">
                                <i
                                    className="bi bi-facebook"
                                />
                            </a>
                            <a href="/">
                                <i
                                    className="bi bi-instagram"
                                />
                            </a>
                            <a href="/">
                                <i
                                    className="bi bi-twitter"
                                />
                            </a>
                        </p>
                    </div>
                    <hr className="w-100 clearfix d-md-none"/>
                </div>
            </section>
            <div className="bottom container-fluid text-center">
                <div className="d-inline-block"><SelectEnvComponent></SelectEnvComponent></div>
                <p>Everdreamsoft @2022</p>
            </div>
        </footer>
    );
}

export default Footer;
